import { OobMode } from '@phx-husky/auth-service';
import { SecureLevel } from '@phx-husky/auth-wrapper';

import { AUTHSettings } from '~/layout/Auth/models';
import { authLinkMapper } from '~/mappers/authLinks';

export const getMappedAuthLinks = (
  authSettings: Array<AUTHSettings>,
  localeCode: string
) => {
  const authLinksSettings = authSettings.find(
    ({ tags, publishDetails: { locale } }) =>
      tags.includes(process.env.GATSBY_CONTENTSTACK_BRAND_TAG as string) &&
      locale === localeCode
  );

  if (!authLinksSettings) {
    throw new Error('Auth links settings not exist');
  }

  return authLinkMapper(authLinksSettings.authLinks);
};

export const getMagicLinkHandlerSecureLevel = ({
  oobMode,
}: {
  oobMode: OobMode;
}): SecureLevel => {
  switch (oobMode) {
    case OobMode.resetPassword:
      return SecureLevel.Unlogged;
    case OobMode.verifyAndChangeEmail:
    case OobMode.recoverEmail:
      return SecureLevel.Public;
    default:
      return SecureLevel.LoggedOrNonVerified;
  }
};
